import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as Arrow } from "../assets/images/arrow.svg";
import { useDispatch, useSelector } from 'react-redux';
import { deleteTag } from '../actions/tags'
import { getBenefits } from '../actions/benefits'
import { FaTrash, FaPen } from 'react-icons/fa';

type PropsTag = {
  elements?: any;
  id?: number;
  isForm?: boolean;
  setCurrentTagId?: any;
  isSelected?: boolean;
  isPlant?: boolean;
  onClick?: (event: any) => void;
};

const Tag: React.FC<PropsTag> = ({ isSelected, setCurrentTagId, isForm = false, elements, onClick, isPlant }) => {
  
  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    dispatch(getBenefits())
  }, [dispatch])
  // useEffect(() => {
  //   console.log(tag.color)
  // }, [tag])
  const backgroundColorItems = isPlant ? '#1F460C' : '#fff'

  // if (isPlant) {
  const plantBenefits = useSelector((state: any) => state.benefits.filter((benefit) => isPlant ? elements.benefits.includes(benefit._id) : ''))
  // }

  const redirectDetailPost = () => {
    if (!isForm && isPlant) {
      return history.push(`/detail/plants/${elements._id}`, elements)
    }
  }
  
  return (
    <>
      <span onClick={redirectDetailPost} className={`${isSelected ? '_bg-warning' : ''} _bg-white _cursor-pointer _w-auto _mr-xs _items-center _rounded-card ${isPlant ? '_py-xxs _px-sm _pr-xs _mb-sm' : '_px-sm _font-bold'}  _text-sm _leading-loose _flex`} style={{ color: `${elements.color ? elements.color : '#fff' }`, backgroundColor: backgroundColorItems}}>
        <p>{elements.title}</p>
        {isForm && (
          <div className="_ml-sm">
            <button className="_text-black hover:_bg-gray _rounded-card _p-xxs" type="button" onClick={() => setCurrentTagId(elements._id)}>
              <FaPen />
            </button>
            <button className="_ml-xs _text-warning _p-xxs hover:_bg-gray _rounded-card" type="button" onClick={() => dispatch(deleteTag(elements._id))}>
              <FaTrash />
            </button>
          </div>
        )}
        {isPlant && (

          // <div className="_ml-sm _bg-primary _bg-no-repeat _bg-cover _bg-center _rounded-circle" style={{ height: '27px', width: '27px', backgroundImage: `url(${tag.image})` }}/>
          <div className="_flex _items-center">
            <div className="_flex ">
                {plantBenefits.length && (
                  <div className="_ml-xs _bg-white _rounded-circle" style={{ height: '27px', width: '27px' }}>
                     <img src={plantBenefits[0].image} alt={plantBenefits[0].title} className="_bg-no-repeat _bg-cover _bg-center _p-xxs _w-full _h-full" />
                  </div>
  
                )}
                { plantBenefits.length > 1 && (
                  <div className="_-ml-xs _bg-darkengreen _border _border-white _rounded-circle _flex _justify-center  _text-white  _items-center" style={{ height: '27px', width: '27px' }}>
                    <p className="_text-sm"> +{plantBenefits.length - 1} </p>
                  </div>
                )}
              </div>
            <Arrow className="_text-white _fill-current _ml-xs" style={{ height: '1rem'}} />
          </div>
        )}
      </span>
    </>
  );
};

export default Tag;
